import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { union_type, record_type, string_type, list_type, class_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { UserSubscriptionDetail_$reflection } from "../../../../Logos.Shared/Domain/Entity/User.fs.js";
import { Busy, Busy_$reflection } from "../../SharedView.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.3/Result.js";
import { cmdOfAsync } from "../../../Infrastructure/Util/Elmish.fs.js";
import { singleton } from "../../../fable_modules/fable-library-js.4.19.3/AsyncBuilder.js";
import { getUserSubscriptionDetails } from "../../../AppDomain/UseCase/User.fs.js";
import { AppRootModule_getSelectedOrgId, appRoot } from "../../../Infrastructure/AppRoot.fs.js";
import { ofArray, singleton as singleton_1, empty } from "../../../fable_modules/fable-library-js.4.19.3/List.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { createElement } from "react";
import React from "react";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { container } from "../../Component/ViewContainer.fs.js";
import { Daisy_progressState, Daisy_error } from "../../Component/Component.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.8.0/./Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.4.19.3/Util.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.4.2.1/./DaisyUI.fs.js";
import { join } from "../../../fable_modules/fable-library-js.4.19.3/String.js";
import { map, delay, toList } from "../../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { DateTime_dateTimeToStringWithDayName } from "../../../AppDomain/Util.fs.js";
import { toLocalTime } from "../../../fable_modules/fable-library-js.4.19.3/DateOffset.js";

export class State extends Record {
    constructor(UserId, UserSubscriptionDetails, IsBusy, Errors) {
        super();
        this.UserId = UserId;
        this.UserSubscriptionDetails = UserSubscriptionDetails;
        this.IsBusy = IsBusy;
        this.Errors = Errors;
    }
}

export function State_$reflection() {
    return record_type("Presentation.Pages.UserSubscriptions.State", [], State, () => [["UserId", class_type("System.Guid")], ["UserSubscriptionDetails", list_type(UserSubscriptionDetail_$reflection())], ["IsBusy", Busy_$reflection()], ["Errors", list_type(string_type)]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GetUserSubscriptionDetailsResponse", "ApiError"];
    }
}

export function Msg_$reflection() {
    return union_type("Presentation.Pages.UserSubscriptions.Msg", [], Msg, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(UserSubscriptionDetail_$reflection()), list_type(string_type)], FSharpResult$2, () => [[["ResultValue", list_type(UserSubscriptionDetail_$reflection())]], [["ErrorValue", list_type(string_type)]]])]], [["Item", class_type("System.Exception")]]]);
}

export function getUserSubscriptionDetailsCmd(userId) {
    return cmdOfAsync((Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])), () => singleton.Delay(() => getUserSubscriptionDetails(appRoot.UserService, AppRootModule_getSelectedOrgId(), userId)));
}

export function init(userId) {
    return [new State(userId, empty(), new Busy(1, []), empty()), getUserSubscriptionDetailsCmd(userId)];
}

export function update(msg, state) {
    if (msg.tag === 1) {
        return [new State(state.UserId, state.UserSubscriptionDetails, new Busy(0, []), singleton_1(msg.fields[0].message)), Cmd_none()];
    }
    else if (msg.fields[0].tag === 1) {
        return [new State(state.UserId, state.UserSubscriptionDetails, new Busy(0, []), msg.fields[0].fields[0]), Cmd_none()];
    }
    else {
        return [new State(state.UserId, msg.fields[0].fields[0], new Busy(0, []), state.Errors), Cmd_none()];
    }
}

export function IndexView(indexViewInputProps) {
    let init_1, children, elems_1, children_5, children_3, children_11;
    const userId = indexViewInputProps.userId;
    const state_1 = ((init_1 = init(userId), React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, update, (_arg, _arg_1) => {
    }), undefined, [])))[0];
    return container([Daisy_error(state_1.Errors), (children = singleton_1(createElement(Daisy_progressState, {
        busy: state_1.IsBusy,
    })), createElement("div", {
        className: "form-control",
        children: reactApi.Children.toArray(Array.from(children)),
    })), createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "table-zebra"], ["className", "table-xs"], ["className", "table-pin-rows"], ["className", "table-pin-cols"], ["className", join(" ", ["w-full"])], (elems_1 = [(children_5 = singleton_1((children_3 = ofArray([createElement("th", {
        width: 20 + "%",
        children: "Product",
    }), createElement("th", {
        width: 20 + "%",
        children: "Subscription",
    }), createElement("th", {
        width: 30 + "%",
        children: "Date Allocated",
    }), createElement("th", {
        width: 30 + "%",
        children: "Renewal/Expiry Date",
    })]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children_3)),
    }))), createElement("thead", {
        children: reactApi.Children.toArray(Array.from(children_5)),
    })), (children_11 = toList(delay(() => map((userSubscriptionDetail) => {
        let children_7;
        const children_9 = ofArray([createElement("td", {
            children: userSubscriptionDetail.ProductName,
        }), createElement("td", {
            children: userSubscriptionDetail.SubscriptionId,
        }), createElement("td", {
            children: DateTime_dateTimeToStringWithDayName(toLocalTime(userSubscriptionDetail.DateAllocated)),
        }), (children_7 = singleton_1(DateTime_dateTimeToStringWithDayName(toLocalTime(userSubscriptionDetail.ExpiryDate))), createElement("td", {
            children: reactApi.Children.toArray(Array.from(children_7)),
        }))]);
        return createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_9)),
        });
    }, state_1.UserSubscriptionDetails))), createElement("tbody", {
        children: reactApi.Children.toArray(Array.from(children_11)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))]);
}

